var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.childData,
            rules: _vm.rules,
            "label-position": "right",
            "label-width": "130px"
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "报名内容", prop: "itemName" } },
                    [
                      _c("el-input", {
                        staticClass: "form-item-width",
                        staticStyle: { width: "200px" },
                        attrs: { placeholder: "请输入报名内容", clearable: "" },
                        model: {
                          value: _vm.childData.itemName,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "itemName", $$v)
                          },
                          expression: "childData.itemName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "价格(元)", prop: "itemPrice" } },
                    [
                      _c("el-input-number", {
                        attrs: { min: 0.01, max: 999999, precision: 2 },
                        model: {
                          value: _vm.childData.itemPrice,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "itemPrice", $$v)
                          },
                          expression: "childData.itemPrice"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "最大报名人数(人)", prop: "totalNumber" }
                    },
                    [
                      _c("el-input-number", {
                        attrs: { min: 0, max: 999999, precision: 0 },
                        model: {
                          value: _vm.childData.totalNumber,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "totalNumber", $$v)
                          },
                          expression: "childData.totalNumber"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "核销次数(次)", prop: "checkNum" } },
                    [
                      _c("el-input-number", {
                        attrs: { min: 1, max: 999999, precision: 0 },
                        model: {
                          value: _vm.childData.checkNum,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "checkNum", $$v)
                          },
                          expression: "childData.checkNum"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "有效期(月)", prop: "validPeriod" } },
                    [
                      _c("el-input-number", {
                        attrs: { min: 1, max: 999999, precision: 0 },
                        model: {
                          value: _vm.childData.validPeriod,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "validPeriod", $$v)
                          },
                          expression: "childData.validPeriod"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "绑定设备", prop: "deviceId" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "200px" },
                          attrs: {
                            filterable: "",
                            clearable: "",
                            placeholder: "请选择绑定设备"
                          },
                          model: {
                            value: _vm.childData.deviceId,
                            callback: function($$v) {
                              _vm.$set(_vm.childData, "deviceId", $$v)
                            },
                            expression: "childData.deviceId"
                          }
                        },
                        _vm._l(_vm.deviceOption, function(item) {
                          return _c("el-option", {
                            key: item.deviceId,
                            attrs: {
                              label: item.deviceName,
                              value: item.deviceId
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "排序", prop: "itemOrder" } },
                    [
                      _c("el-input-number", {
                        attrs: { min: 0, max: 999999, precision: 0 },
                        model: {
                          value: _vm.childData.itemOrder,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "itemOrder", $$v)
                          },
                          expression: "childData.itemOrder"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handCancle } }, [
            _vm._v(_vm._s(_vm.$t("button.cancel")))
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handCreate } },
            [_vm._v(_vm._s(_vm.$t("button.confirm")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }